import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const mutation = gql`
  mutation ModifyBulkReward($input: ModifyBulkRewardInput!) {
    modifyBulkReward(input: $input) {
      uuid
      status
    }
  }
`

export const modifyBulkRewardKey = getQueryNames(mutation)[0]

export default mutation
